import { Heading, TableColumnType, TableComponent } from "@tutellus/tutellus-components"
import { useTranslation } from "react-i18next"
import { useFormatDates } from "../../../hooks/useFormatDates"
import { UserSyntheticDepositList } from "../../../domain/synthetic/Models/UserSyntheticDepositList"
import { UserSyntheticDepositSerialized } from "../../../domain/synthetic/Models/UserSyntheticDeposit"
import { TokenAmountCell } from "../../TableCells/TokenAmountCell"
import { useFormatAmounts } from "../../../hooks/useFormatAmounts"

type WalletNFTTableProps = { userDeposits: UserSyntheticDepositList; currencyID: string }

export const WalletNFTTable = ({ userDeposits, currencyID }: WalletNFTTableProps) => {
  const { t } = useTranslation("wallet")
  const { formatRemainingTime } = useFormatDates()
  const { formatCurrencyAmounts } = useFormatAmounts()

  const columns: TableColumnType<UserSyntheticDepositSerialized>[] = [
    { key: "id", header: "ID", content: ({ id }) => `NFT-${id}`, sortValue: ({ id }) => id },
    {
      key: "deposited.number",
      header: t("deposited"),
      content: ({ deposited }) => <TokenAmountCell tokenID={deposited.tokenID} amount={deposited.number} />,
      align: "right",
    },
    {
      key: "deposited.currencyAmounts",
      header: t("value"),
      sortValue: ({ deposited }) => formatCurrencyAmounts(deposited.currencyAmounts),
      content: ({ deposited }) => deposited.currencyAmounts?.find((c) => c.currencyID === currencyID)?.formatted,
      align: "right",
    },
    {
      key: "remainingLockTimeInSeconds",
      header: t("lock"),
      content: ({ remainingLockTimeInSeconds }) => formatRemainingTime(remainingLockTimeInSeconds),
      align: "right",
    },
    {
      key: "syntheticAmount.number",
      header: t("votePower"),
      content: ({ syntheticAmount }) => (
        <TokenAmountCell tokenID={syntheticAmount.tokenID} amount={syntheticAmount.number} />
      ),
      align: "right",
    },
  ]

  return (
    <>
      <Heading align="center">{t("nft")}</Heading>
      <TableComponent
        columns={columns}
        data={userDeposits.serialize().items}
        defaultSort={{ key: "id", direction: "asc" }}
      />
    </>
  )
}
